import { Button, CircularProgress, InputAdornment } from '@mui/material';
import classNames from 'classnames';
import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { ReactComponent as HidePasswordIcon } from '../../assets/icons/Login/passwordHideIcon.svg';
import { ReactComponent as ShowPasswordIcon } from '../../assets/icons/Login/passwordShowIcon.svg';
import TextField from '../../components/Inputs/TextField';
import { useLoginService } from '../../services/loginService/index';
import { useSignUpService } from '../../services/signUpService';
import rootStyles from '../Login/index.module.scss';
import formStyles from '../Login/LoginContent/index.module.scss';

function NewPasswordChallenge() {
  const [isShowPassword, setIsShowPassword] = useState<{
    password: boolean;
    confirmPassword: boolean;
  }>({
    password: false,
    confirmPassword: false,
  });
  const {
    state: { errorMessage, challenge, forgotPassword, isWelcome },
  } = useLoginService();
  const {
    state,
    state: { isWelcomeState },
  } = useSignUpService();
  const {
    register,
    handleSubmit,
    formState,
    clearErrors,
    setError,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });
  const onSubmit = async (formData: Partial<{ newPassword: string }>) => {
    challenge.onFinish(formData.newPassword ?? '');
  };

  const tooglePasswordType = (name: 'password' | 'confirmPassword') => {
    setIsShowPassword({
      ...isShowPassword,
      [name]: !isShowPassword[name],
    });
  };
  const validatePasswords = (confirmPassword: string) => {
    const newPassword = watch('newPassword');
    if (newPassword && newPassword !== confirmPassword) {
      setError('confirmPassword', {
        type: 'custom',
        message: 'Passwords do not match.',
      });
    }
  };
  return (
    <div
      className={classNames(formStyles.root, rootStyles.boxContainer, 'w-full', {
        [rootStyles.hide]:
          isEmpty(challenge) ||
          forgotPassword.state !== undefined ||
          !!(isWelcomeState || isWelcome),
      })}
    >
      <span className={rootStyles.title}>Reset your password </span>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col">
          <TextField
            label="Password"
            wrapperClassName={classNames(formStyles.inputWrapper, formStyles.password)}
            error={!!errors?.newPassword}
            helperText={errors?.newPassword?.message}
            inputClassName={formStyles.inputField}
            type={isShowPassword.password ? 'text' : 'password'}
            hideErrorIcon
            InputLabelProps={{
              classes: {
                shrink: formStyles.shrink,
              },
            }}
            variant="outlined"
            {...register('newPassword', {
              required: 'Please enter password',
              pattern: {
                value: /(?=.{8,})/,
                message: 'Password should include at least 8 characters.',
              },
            })}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" className={formStyles.endAdornment}>
                  <div onClick={() => tooglePasswordType('password')} className="p-0">
                    {isShowPassword.password ? <HidePasswordIcon /> : <ShowPasswordIcon />}
                  </div>
                </InputAdornment>
              ),
            }}
          />
          <span
            className={classNames(formStyles.passwordHelperText, {
              [formStyles.error]: !!errors?.newPassword,
            })}
          >
            Password should include at least 8 characters.
          </span>
        </div>
        <TextField
          label="Confirm new password"
          wrapperClassName={formStyles.inputWrapper}
          error={!!errors?.confirmPassword}
          helperText={errors?.confirmPassword?.message}
          inputClassName={formStyles.inputField}
          type={isShowPassword.confirmPassword ? 'text' : 'password'}
          hideErrorIcon
          InputLabelProps={{
            classes: {
              shrink: formStyles.shrink,
            },
          }}
          variant="outlined"
          {...register('confirmPassword')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" className={formStyles.endAdornment}>
                <div onClick={() => tooglePasswordType('confirmPassword')} className="p-0">
                  {isShowPassword.confirmPassword ? <HidePasswordIcon /> : <ShowPasswordIcon />}
                </div>
              </InputAdornment>
            ),
          }}
          onBlur={({ target: { value } }) => validatePasswords(value)}
          onInput={() => clearErrors('confirmPassword')}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={!(formState.isValid && watch('newPassword') === watch('confirmPassword'))}
          className={clsx(formStyles.submitBtn, 'rounded-4')}
        >
          {isSubmitting ? <CircularProgress size={15} color="inherit" /> : 'Reset password '}
        </Button>
        {errorMessage || state.errorMessage ? (
          <div className={formStyles.error}>{errorMessage || state.errorMessage}</div>
        ) : null}
      </form>
    </div>
  );
}
export default observer(NewPasswordChallenge);
